module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b-app-structure",
    class: [_vm.bodyClasses],
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "b-app-structure__main"
  }, [_c('section', {
    staticClass: "b-login-holder"
  }, [_c('div', {
    staticClass: "w-app-login-logo"
  }, [(_vm.loginType !== 'account' || _vm.allowBranding) ? _c('img', {
    staticClass: "w-app-login-logo__image",
    attrs: {
      "src": require("../assets/images/teamwork-logo.svg"),
      "alt": "Teamwork.com"
    }
  }) : _vm._e()]), _c('loading', {
    attrs: {
      "isLoading": _vm.siteLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.siteLoading) ? _c('div', {
    staticClass: "content",
    class: {
      'content-persona': _vm.isPersonaCapture, 'content-verify-email': _vm.isEmailValidation
    }
  }, [(_vm.siteNotFound && !_vm.fatalError) ? _c('site-not-found') : _vm._e(), (_vm.showSiteLogo) ? _c('div', {
    staticClass: "w-app-login-site-logo"
  }, [_c('img', {
    staticClass: "w-app-login-site-logo__image",
    attrs: {
      "src": _vm.siteLogo,
      "alt": _vm.siteName
    }
  })]) : _vm._e(), (!_vm.siteNotFound && _vm.fatalError) ? _c('error-message') : _vm._e(), (!_vm.siteNotFound && !_vm.fatalError) ? _c('router-view') : _vm._e()], 1) : _vm._e()], 1)]), (!_vm.isEmailValidation) ? _c('div', {
    staticClass: "b-app-structure__secondary"
  }, [(_vm.inGenericLogin) ? _c('div', {
    staticClass: "b-app-structure__secondary-content"
  }, [_c('p', [_vm._v(_vm._s("Don't have an account yet?"))]), _vm._m(0)]) : _vm._e(), _c('MarketingContent', {
    attrs: {
      "display": _vm.displayMarketingContent
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "w-button",
    attrs: {
      "href": "https://www.teamwork.com/signup"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Sign up")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a02523dc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 611
// module chunks = 1